namespace GeniuzPOS.Purchase {
    export class PoPurOrderDtColumns {
        static columnsKey = 'Purchase.PoPurOrderDt';
    }
}
